'use strict';

var _ = require('lodash');
var ProfileChartSearchCriteriaService = function ProfileChartSearchCriteriaService(SearchCriteriaRule, featureToggleService) {
  function getProfileLevelsRule(masterData, profileLevelKey) {
    var profileLevels = _.chain(masterData).map(profileLevelKey).compact().uniq().join().value();
    return new SearchCriteriaRule({
      category: 'Product Group',
      field: 'profileLevels',
      operator: '=',
      leftOperand: profileLevels
    });
  }
  function createProfileSearchRulesForMarketScreen(masterData, selectedDimension) {
    var rules = [];
    masterData = _.uniqBy(masterData, 'marketDemandId');
    if (masterData.length === 0) {
      return rules;
    }
    _.forEach(masterData, function (masterDataObj) {
      var marketDemandId = masterDataObj.marketDemandId;
      var referenceCurveMarketDemandId = masterDataObj.referenceCurveMarketDemandId;
      var profileLevelKey = _.toUpper(selectedDimension) === 'REGULAR' ? 'regularProfileLevel' : 'mappedProfileLevel';
      rules.push(new SearchCriteriaRule({
        category: 'Product Group',
        field: 'marketDemandId',
        operator: '=',
        leftOperand: marketDemandId
      }));
      rules.push(new SearchCriteriaRule({
        category: 'Product Group',
        field: 'referenceCurveMarketDemandId',
        operator: '=',
        leftOperand: referenceCurveMarketDemandId
      }));
      if (featureToggleService.isEnabled('SEASONAL_AVERAGE_REFERENCE')) {
        var profileLevelRule = getProfileLevelsRule(masterData, profileLevelKey);
        if (!_.isEmpty(profileLevelRule.leftOperand)) {
          rules.push(profileLevelRule);
        }
      }
      rules.push(new SearchCriteriaRule({
        category: 'Product Group',
        field: 'flowType',
        operator: '=',
        leftOperand: _.toUpper(selectedDimension)
      }));
      var curveIds = _.chain(masterData).map(function (detail) {
        return [detail.classGroup, detail.posName, _.toUpper(selectedDimension)].join('_');
      }).flatten().uniq().join().value();
      rules.push(new SearchCriteriaRule({
        category: 'Product Group',
        field: 'curveIds',
        operator: '=',
        leftOperand: curveIds
      }));
      rules.push(new SearchCriteriaRule({
        category: 'Origin',
        field: 'origin',
        operator: '=',
        leftOperand: masterDataObj.origin
      }));
      rules.push(new SearchCriteriaRule({
        category: 'Destination',
        field: 'destination',
        operator: '=',
        leftOperand: masterDataObj.destination
      }));
      if (featureToggleService.isEnabled('MAPPED_MODE')) {
        rules.push(new SearchCriteriaRule({
          category: 'Reference Metric',
          field: 'referenceMetric',
          operator: '=',
          leftOperand: _.toUpper(selectedDimension)
        }));
      }
      rules.push(new SearchCriteriaRule({
        category: 'Market Entity',
        field: 'marketEntity',
        operator: '=',
        leftOperand: masterDataObj.entity
      }));
      var curveIdsForURD = _.chain(masterData).map(function (detail) {
        return [detail.classGroup, detail.posName, detail.seasonOverride || detail.season, _.toUpper(selectedDimension)].join('_');
      }).flatten().uniq().join().value();
      rules.push(new SearchCriteriaRule({
        category: 'Product Group',
        field: 'curveIdsForURD',
        operator: '=',
        leftOperand: curveIdsForURD
      }));
      if (masterDataObj.dowGroup) {
        rules.push(new SearchCriteriaRule({
          category: 'Day Of Week Group',
          field: 'dayOfWeekGroup',
          operator: '=',
          leftOperand: masterDataObj.dowGroup
        }));
      }
    });
    return rules;
  }
  function createProfileSearchRulesForFlightScreen(masterData) {
    var rules = [];
    if (masterData) {
      rules.push(new SearchCriteriaRule({
        category: 'Flight',
        field: 'flightId',
        operator: '=',
        leftOperand: masterData[0].flightId
      }));
      rules.push(new SearchCriteriaRule({
        category: 'FlightId',
        field: 'referenceCurveFlightId',
        operator: '=',
        leftOperand: masterData[0].referenceCurveFlightId
      }));
      var curveIds = _.chain(masterData).map(function (detail) {
        return detail.legCabinId;
      }).flatten().uniq().join().value();
      rules.push(new SearchCriteriaRule({
        category: 'Product Group',
        field: 'curveIds',
        operator: '=',
        leftOperand: curveIds
      }));
      if (featureToggleService.isEnabled('SEASONAL_AVERAGE_REFERENCE')) {
        var profileLevelRule = getProfileLevelsRule(masterData, 'profileLevel');
        if (!_.isEmpty(profileLevelRule.leftOperand)) {
          rules.push(profileLevelRule);
        }
      }
      rules.push(new SearchCriteriaRule({
        category: 'Airline',
        field: 'airlineCode',
        operator: '=',
        leftOperand: _.words(masterData[0].flightId)[0]
      }));
      rules.push(new SearchCriteriaRule({
        category: 'Cabin',
        field: 'cabinCode',
        operator: '=',
        leftOperand: masterData[0].cabinCode
      }));
      rules.push(new SearchCriteriaRule({
        category: 'Season',
        field: 'season',
        operator: '=',
        leftOperand: masterData[0].season
      }));
      rules.push(new SearchCriteriaRule({
        category: 'Day of Week',
        field: 'dayOfWeekGroup',
        operator: '=',
        leftOperand: masterData[0].dowGroup
      }));
      rules.push(new SearchCriteriaRule({
        category: 'Flight Entity',
        field: 'flightEntity',
        operator: '=',
        leftOperand: masterData[0].entity
      }));
      rules.push(new SearchCriteriaRule({
        category: 'Origin',
        field: 'origin',
        operator: '=',
        leftOperand: _.words(masterData[0].leg)[0]
      }));
      rules.push(new SearchCriteriaRule({
        category: 'Destination',
        field: 'destination',
        operator: '=',
        leftOperand: _.words(masterData[0].leg)[1]
      }));
      rules.push(new SearchCriteriaRule({
        category: 'Flight Number',
        field: 'number',
        operator: '=',
        leftOperand: masterData[0].flightNumber
      }));
    }
    return rules;
  }
  return {
    createProfileSearchRulesForMarketScreen: createProfileSearchRulesForMarketScreen,
    createProfileSearchRulesForFlightScreen: createProfileSearchRulesForFlightScreen
  };
};
ProfileChartSearchCriteriaService.$inject = ['SearchCriteriaRuleFactory', 'FeatureToggleService'];
module.exports = ProfileChartSearchCriteriaService;